import HistoryReport from "./HistoryReport";

export default HistoryReport;
